export default "__VITE_ASSET__7cc2f08f__"